module.exports = __webpack_public_path__ + "img/IMG-20200310-WA0094.3e3a4a4a.jpg";